import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getAdminSection } from '../shell/adminSections';
import IntroScreen from '../intro/IntroScreen';
import ProductsScreen from '../products/ProductsScreen';
import CategoriesScreen from '../categories/CategoriesScreen';
import LabelsScreen from '../labels/LabelsScreen';
import SizeChartsScreen from '../sizecharts/SizeChartsScreen';
import BannersScreen from '../banners/BannersScreen';
import TestimonialsScreen from '../testimonials/TestimonialsScreen';
import ContactsScreen from '../contacts/ContactsScreen';

const SCREENS = {
  intro: IntroScreen,
  products: ProductsScreen,
  categories: CategoriesScreen,
  labels: LabelsScreen,
  sizecharts: SizeChartsScreen,
  banners: BannersScreen,
  testimonials: TestimonialsScreen,
  contacts: ContactsScreen,
};

export default function AdminDashboard() {
  const location = useLocation();
  const navigate = useNavigate();
  const section = getAdminSection(location.hash);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    if (!location.hash) navigate('/admin/dashboard#intro', { replace: true });
  }, [location.hash, navigate]);

  const onMessage = (text) => {
    setMsg(text);
    setTimeout(() => setMsg(''), 3200);
  };

  const Screen = SCREENS[section.id] || IntroScreen;

  return (
    <div className="admin-workspace" key={section.id}>
      <header className="admin-header">
        <div>
          <p className="admin-header__eyebrow">NAYAVARNAM Admin</p>
          <h1>{section.title}</h1>
          <p>{section.subtitle}</p>
        </div>
        {msg && <div className="admin-toast">{msg}</div>}
      </header>
      <div className="admin-screen">
        <Screen onMessage={onMessage} />
      </div>
    </div>
  );
}
